import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import fractionToInt from "../../../util/fractionToInt";
import { useStore } from "../../../store/store";
import { SelectChangeEvent } from "@mui/material";

interface UpdateObj {
  unitSize?: string;
  exactConfig?: string;
  unitSizeFraction?: string;
  addScreen?: string;
  screenType?: string;
  screenPocket?: string;
  screenLayout?: string;
  screenMeshColor?: string;
  screenColor?: string;
  jamb?: string;
}

function useWidthSelector(setSliderConfig: Dispatch<SetStateAction<string>>) {
  const addToQuote = useStore((state) => state.addToQuote);

  const sliderP = useStore((state) => state.quote.sliderPocket);
  const isPocketing = sliderP === "With Pocket";

  const handleError = useStore((state) => state.handleError);

  const errors = useStore((state) => state.errors);

  const width = useStore((state) => state.quote.unitSize);
  const fraction = useStore((state) => state.quote.unitSizeFraction);

  const screenType = useStore((state) => state.quote.screenType);
  const screen = useStore((state) => state.quote.addScreen);

  const [min, setMin] = useState(48);
  const [max, setMax] = useState({ num: 576, string: "576" });

  const unitSize = useStore((state) => state.quote.unitSize);
  const unitSizeFraction = useStore((state) => state.quote.unitSizeFraction);

  const overallWidth = fractionToInt(unitSize, unitSizeFraction);

  useEffect(() => {
    if (!isPocketing) {
      if (min === 48 && max.num === 576) return;
      setMin(48);
      setMax({ num: 576, string: "576" });
      (overallWidth >= 48 && overallWidth <= 576) || !overallWidth
        ? handleError("widthErr", "")
        : handleError("widthErr", 'Enter width between 48 - 576"');
    }
    if (isPocketing) {
      if (min === 24 && max.num === 452) return;
      setMin(24);
      setMax({ num: 452, string: "452" });
      (overallWidth >= 24 && overallWidth <= 452) || !overallWidth
        ? handleError("widthErr", "")
        : handleError("widthErr", 'Enter width between 24 - 452"');
    }
  }, [isPocketing]);

  const handleWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    let update: UpdateObj = { unitSize: value, exactConfig: "" };

    const overall = fractionToInt(value, fraction);

    if (screenType === "Centor Flat Screen/Shade") {
      if (
        overall > 348.8125 ||
        (screen === "Add Double Shade" && overall > 316.8125) ||
        (screen === "Add Shade" && overall > 159.8125) ||
        (screen === "Add Combo Screen/Shade" && overall > 161.8125) ||
        (screen === "Add Screen" && overall > 175.8125)
      ) {
        update = {
          ...update,
          addScreen: "",
          screenType: "",
          screenPocket: "",
          screenLayout: "",
          screenMeshColor: "",
          screenColor: "",
          jamb: "",
        };
      }
    }

    if (overall > max.num) {
      handleError("widthErr", `Width can not exceed ${max.string}"`);
    } else if (overall <= max.num && overall >= min) {
      handleError("widthErr", "");
      // addToQuote({unitSize: value}, "unitSize")
    } else if (overall < min) {
      handleError("widthErr", `Width must exceed ${min}"`);
    }

    addToQuote(update, "unitSize");
    setSliderConfig("");
    handleError("primaryDoorErr", "");
  };

  const handleFractionChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;

    let update: UpdateObj = { exactConfig: "" };

    const overall = fractionToInt(width, value);

    if (overall > max.num) {
      handleError("widthErr", `Width can not exceed ${max.string}"`);
    } else if (overall <= max.num && overall >= min) {
      handleError("widthErr", "");
    }

    if (value === "") {
      update = { unitSizeFraction: "" };
    } else {
      update = { unitSizeFraction: value };
    }

    if (screenType === "Centor Flat Screen/Shade") {
      if (
        overall > 348.8125 ||
        (screen === "Add Double Shade" && overall > 316.8125) ||
        (screen === "Add Shade" && overall > 159.8125) ||
        (screen === "Add Combo Screen/Shade" && overall > 161.8125) ||
        (screen === "Add Screen" && overall > 175.8125)
      ) {
        update = {
          ...update,
          addScreen: "",
          screenType: "",
          screenPocket: "",
          screenLayout: "",
          screenMeshColor: "",
          screenColor: "",
          jamb: "",
        };
      }
    }

    addToQuote(update);
    setSliderConfig("");
    handleError("primaryDoorErr", "");
  };

  return {
    handleFractionChange,
    handleWidthChange,
    widthErr: errors.widthErr,
    isPocketing,
    sliderP,
    width,
    fraction,
  };
}

export default useWidthSelector;
